import { path } from 'ramda';

export const themeColor = (color) => path(['theme', 'color', color]);
export const layoutProp = (prop) => path(['theme', 'layout', prop]);
export const zIndex = (prop) => path(['theme', 'zIndex', prop]);

const DESIGN_WIDTH = 1080;
export const pxToVw = (value) => `${(value / DESIGN_WIDTH) * 100}vmin`;
